import { useQuery } from '@tanstack/react-query';
import { camelizeKeys } from 'humps';

import config from 'config';

import { isTeacher } from 'utils/user.utils';

import { QueryKeys } from 'queries/QueryKeys';
import { StaleTime } from 'queries/types';
import { ApiResponse } from 'types/api.types';
import { User } from 'types/user.types';

import { useUser } from './useUser';

const getProfile = async (token: string, userId: string) => {
  const data = await fetch(`${config.REST_API_BASE}/users/${userId}`, {
    headers: {
      Accept: 'application/vnd.api+json',
      Authorization: `Bearer ${token}`,
    },
  });

  const response = await data.json();

  return camelizeKeys(response) as unknown as ApiResponse<User>;
};

export const useProfile = () => {
  const { data: user } = useUser();
  const userId = user?.getUsername() ?? '';
  const token = user?.getSignInUserSession()?.getAccessToken().getJwtToken() ?? '';

  const { data, isFetching } = useQuery(QueryKeys.profile(), () => getProfile(token, userId), {
    enabled: !!token && !!userId && !isTeacher(user),
    staleTime: StaleTime.FIFTEEN_MIN,
  });

  return {
    data: data?.data.attributes,
    isFetching,
  };
};
